import React, { useEffect, useState } from 'react'
import { Dropdown } from 'primereact/dropdown'

export default function LtsDropdownEnum(props) {
  const [options, setOptions] = useState([])

  useEffect(() => {
    if (props.forceOptions || !props.loadDataFn) {
      setOptions(props.options || [])
      return
    }

    const loadDataPromise = props.loadDataFnParam ? props.loadDataFn(props.loadDataFnParam) : props.loadDataFn()

    loadDataPromise
      .then((response) => {
        const data = response?.data || []
        setOptions(props.afterLoadDataFn ? props.afterLoadDataFn(data) : data)
      })
      .catch((error) => console.log(error))
  }, [props.forceOptions, props.options, props.loadDataFn, props.loadDataFnParam, props.afterLoadDataFn])

  const onChange = (e) => {
    props.onChange(e.value)
  }

  const resolveValue = (value) => {
    if (props.resolveValueFn) {
      return props.resolveValueFn(value)
    }
    return value
  }

  const resolveName = () => {
    return props.name
  }

  const resolveLabel = () => {
    if (props.label) {
      return <label>{props.label}</label>
    }
    return null
  }

  return (
    <React.Fragment>
      <span className="p-float-label">
        <Dropdown
          value={resolveValue(props.value)}
          options={options}
          onChange={onChange}
          optionLabel={props.optionLabel || 'label'}
          optionValue={props.optionValue || 'value'}
          dataKey={props.dataKey || props.optionValue || 'value'}
          name={resolveName()}
          disabled={props.disabled}
          itemTemplate={props.itemTemplate}
          style={props.style}
        />
        {resolveLabel()}
      </span>
    </React.Fragment>
  )
}
